import {EvkOption} from "@evomatik/evk-common";
import {EstadoDocumentModel} from "./estado-document.model";

export class EstadoTareaDocumentModel{
    estado: EstadoDocumentModel;
    usuarioAsignado: EvkOption;
    organizacion: EvkOption;
    observaciones: string;
    activo: boolean;
    created: Date;
    createdBy: string;
    updatedBy: string;
}
